export default "__VITE_ASSET__ded6138d__"